export default __webpack_public_path__ + "static/11-ea368280fede791763baa21e4723f16c.png";